// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","content":"Header_content__e8Iuw","contactsBox":"Header_contactsBox__sUGtD","tel":"Header_tel__PBjwf","linkBox":"Header_linkBox__w1-HL"};